import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/konsoll/abonnement")({
	beforeLoad: () => {
		throw redirect({ to: "/account/abonnement" });
	},
});
